import { render, staticRenderFns } from "./property-card.vue?vue&type=template&id=f2f3af3e&"
import script from "./property-card.vue?vue&type=script&lang=js&"
export * from "./property-card.vue?vue&type=script&lang=js&"
import style0 from "./property-card.vue?vue&type=style&index=0&id=f2f3af3e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports